import React from "react";
import styles from "./RedirectBtn.module.css"

const RedirectBtn = ({type}) => {
    return (
        <a href="https://smartsoftge.atlassian.net/servicedesk/customer/portal/15" target="_blank" className={`${styles.redirect} ${styles[type]}`}>sign up</a>
    )
}

export default RedirectBtn